/* eslint-disable no-console */
import { batch } from 'react-redux';

import { setDashboardPending } from './DashboardConfigActions';
import { handleErrors } from './ErrorActions';
import { addSuccess } from './SuccessActions';
import {
  deleteCustomerLogo,
  getCustomerLogo,
  uploadCustomerLogoImage,
} from '../api/upload-customer-logo';
import { getCustomLogoImageUrl } from '../utils/commonUtils';

export const SET_CUSTOMER_LOGO = 'SET_CUSTOMER_LOGO';
export const UPLOAD_CUSTOMER_LOGO = 'UPLOAD_CUSTOMER_LOGO';

export const setCustomerLogo = (image) => ({
  type: SET_CUSTOMER_LOGO,
  payload: image,
});

export const getCustomerLogoImage = (isPublishLogo) => async (dispatch, getState) => {
  const { fetchedCustomerLogo } = getState().customerLogo || {};

  if (fetchedCustomerLogo && !isPublishLogo) {
    return;
  }

  try {
    const response = await getCustomerLogo();

    if (response.hasError) {
      dispatch(handleErrors(response.errors));
      return;
    }

    const imageUrl = getCustomLogoImageUrl(response.resource);

    dispatch(setCustomerLogo(imageUrl));
  } catch (error) {
    console.error(`Error fetching the customer logo: ${JSON.stringify(error)}`);
  }
};

export const saveCustomerLogoImage = (file) => async (dispatch) => {
  try {
    const response = await uploadCustomerLogoImage(file);

    if (response.hasError) {
      dispatch(handleErrors(response.errors));
      return;
    }

    dispatch(addSuccess({ message: 'Upload Logo Saved Successfully' }));

    if (response.resource) {
      const imageUrl = getCustomLogoImageUrl(response.resource);

      dispatch(setCustomerLogo(imageUrl));
    } else {
      dispatch(getCustomerLogoImage(true));
    }
  } catch (error) {
    console.error(`Error saving the customer logo: ${JSON.stringify(error)}`);
    dispatch(handleErrors(error.message));
  }
};

export const deleteCustomLogo = async (dispatch) => {
  dispatch(setDashboardPending(true));

  try {
    const response = await deleteCustomerLogo();

    dispatch(setDashboardPending(false));

    if (response.hasError) {
      dispatch(handleErrors(response.errors));
      return;
    }

    const imageUrl = getCustomLogoImageUrl(response.resource);

    batch(() => {
      dispatch(setCustomerLogo(imageUrl));
      dispatch(addSuccess({ message: 'Brand Logo has been deleted successfully' }));
    });
  } catch (error) {
    console.error(`Error deleting the customer logo: ${JSON.stringify(error)}`);
    dispatch(setDashboardPending(false));
  }
};
